/*
  Sticky buy bar.

  Appears on small screens once the real add-to-cart button has scrolled out of
  view, and hides again the moment it comes back — so it never competes with
  the control it stands in for. Its button submits the actual product form
  rather than duplicating the cart logic.
*/
class PocketroStickyBuy extends HTMLElement {
  connectedCallback() {
    const watchedSelector = this.dataset.watch;
    const watched = watchedSelector ? document.querySelector(watchedSelector) : null;
    this.form = document.querySelector(this.dataset.form || 'form[action*="/cart/add"]');
    this.button = this.querySelector('[data-sticky-submit]');

    if (this.button && this.form) {
      this.button.addEventListener('click', () => {
        this.form.requestSubmit
          ? this.form.requestSubmit(this.form.querySelector('[type="submit"]'))
          : this.form.submit();
      });
    }

    /* Two modes. On the product page the bar stands in for a specific button and
       hides the moment that button is back on screen. Site-wide there is no
       button to watch, so it appears once the visitor is past the fold. */
    if (watched && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.dataset.visible = entry.isIntersecting ? 'false' : 'true';
        },
        { rootMargin: '0px 0px -20% 0px' }
      );
      this.observer.observe(watched);
      return;
    }

    const threshold = parseInt(this.dataset.threshold, 10);
    if (!Number.isFinite(threshold)) return;

    this.onScroll = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.dataset.visible = window.scrollY > threshold ? 'true' : 'false';
      });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('pocketro-sticky-buy')) {
  customElements.define('pocketro-sticky-buy', PocketroStickyBuy);
}
